import script from "./EcommerceInfoAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceInfoAddress.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceInfoAddress.vue?vue&type=style&index=0&id=036b5238&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-036b5238"]])

export default __exports__